'use client';

import { useEffect, useState } from 'react';

import { trackError } from '@/lib/error_tracker';

import SupportEmailLink from '@/components/SupportEmailLink';
import SupportTwitterLink from '@/components/SupportTwitterLink';

export default function Error({ error, reset: _reset }) {
  const [eventId, setEventId] = useState(null);

  useEffect(() => {
    setEventId(trackError(null, 'Next.js Application Error', error, {}));
  }, [error]);

  return (
    <section className="">
      <div className="">
        <p className="">Something went wrong</p>
        <div className="">
          <p>
            Please reach out to <SupportEmailLink sessionOrSessionData={null} />{' '}
            or <SupportTwitterLink sessionOrSessionData={null} /> if this
            continues happening
          </p>

          {(() => {
            if (!eventId) {
              return null;
            }

            return <p className="mt-6">Error code: {eventId}</p>;
          })()}
        </div>
      </div>
    </section>
  );
}
